(function () {
  angular
    .module('app.ics')
    .controller('DeleteInterceptionController', DeleteInterception);


  DeleteInterception.$inject = ['$scope', 'Interceptions', 'interception', 'close'];

  function DeleteInterception($scope, Interceptions, interception, close) {
    var vm = this;

    vm.interception = interception;

    vm.delete = function(){
      Interceptions.delete({id : interception.id}, function(response) {});
      close(vm.interception, 500);
    };
  }
})();
